import React from 'react';
import styled from 'styled-components';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import { COLORS } from '../utils/colors';

const Input = styled.input`
  border: none;
  height: 40px;
  background: transparent;
  width: 100%;
  padding: 5px;
`;

const WrapperButton = styled.button`
  width: 58px;
  height: 48px;
  border-radius: 0px 7px 7px 0px;
  padding: 0;
  margin: 0;
  border: none;
  z-index: 0;
`;

const Main = styled.div`
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  pointer-events: all !important;
  border: 1px solid #3f51b520;
  border-radius: 4px;
  width: 100%;
  height: 42px;
  max-width: 300px;
`;

const SearchBar = (props) => {
  const { searching, setSearching, placeholder } = props;
  let inputRef = React.createRef();

  const clearSearch = () => {
    setSearching('');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      inputRef.current.blur();
    }
  };

  const handleSearch = (event) => {
    if (event.target.value === '') {
      clearSearch();
    }
    const { value } = event.target;
    setSearching(value);
  };

  const mainColor = `${COLORS.S_BG}50`;
  const buttonWrapperColor = `${COLORS.S_BG}F0`;

  return (
    <Main style={{ backgroundColor: mainColor }} style={props.style}>
      <SearchIcon color="primary" className="s-24-i" style={{ minWidth: '40px' }} />
      <Input
        ref={inputRef}
        id="SEARCH_BAR"
        type="text"
        name="name"
        onChange={handleSearch}
        autoComplete="off"
        placeholder={placeholder ? placeholder : 'Search by name ...'}
        value={searching}
        onKeyDown={handleKeyDown}
        style={{ color: COLORS.SECONDARY , height: '42px', fontSize: '12px' }}
      />
      {searching !== '' && (
        <WrapperButton onClick={clearSearch}>
          <CancelIcon
            className="s-24-i txt-danger mt-4 mr-4"
            color={searching.length > 0 ? "error" : "secondary"}
          />
        </WrapperButton>
      )}
    </Main>
  );
};

export { SearchBar };
